export default "__VITE_ASSET__BVLM0etw__"